import AclName from '../AclName.js';

export default [
  AclName.FilesPageFilesList,
  AclName.FilesPageFilesFormAdd,
  AclName.FilesPageFilesFormEdit,

  AclName.FilesBtnFilesMergeFiles,
  AclName.FilesBtnFilesSplitFile,
  AclName.FilesBtnFilesDelete,
  AclName.FilesBtnFilesAdd,
  AclName.FilesBtnFilesEdite,
  AclName.FilesBtnFilesDocumentsProvided,

];